<template>
	<BaseDialog
		v-model:toggle="dialog"
		:fullscreen="fullscreen"
		:force-fullscreen="fullscreen"
		close-on-escape
		:handle-prev-route="handlePrevRoute"
		@dialogClose="close"
	>
		<template v-if="$slots.activator" #activator="activatorProps">
			<slot name="activator" v-bind="activatorProps"></slot>
		</template>
		<template #default="{ isActive }">
			<template v-if="id && !containerId && file">
				<PdfViewer
					v-if="showWhat(file) === 'pdf'"
					:id="id"
					@close="close"
					@loading="loading = false"
					:height-factor="heightFactor"
				></PdfViewer>
				<ImagePreview
					v-if="showWhat(file) === 'img'"
					:document-id="id"
					:download-name="documentName({ id: id, file: undefined })"
					:flat="true"
					:max-height="1000"
					close-btn
					@close="close"
				></ImagePreview>
			</template>

			<DocumentContainerView
				v-else-if="!id && containerId"
				:id="containerId"
				@close="isActive.value = false"
			></DocumentContainerView>
		</template>
	</BaseDialog>
</template>

<script setup lang="ts">
import BaseDialog from '@/components/templates/BaseDialog.vue'
import { useDocumentStore } from '@/stores/modules/document'
import PdfViewer from 'templates/PdfViewer.vue'
import { onBeforeMount, ref } from 'vue'
import DocumentContainerView from './DocumentContainerView.vue'
import ImagePreview from '@/components/templates/ImagePreview.vue'

const { id, fullscreen, containerId } = defineProps({
	id: {
		type: Number,
		default: undefined,
	},
	containerId: {
		type: Number,
		default: undefined,
	},
	fullscreen: {
		default: true,
		required: false,
		type: Boolean,
	},
	heightFactor: {
		default: 1,
		required: false,
		type: Number,
	},
	handlePrevRoute: {
		default: true,
		required: false,
		type: Boolean,
	},
})
const emit = defineEmits(['close'])

const { show, documentName, showWhat } = useDocumentStore()

const file = ref<Api.Document>()

onBeforeMount(async () => {
	if (id && !containerId) {
		file.value = (await show({ id: id })) as Api.Document
	}
})

const dialog = defineModel('dialog', { default: true })
const loading = ref(true)

const close = () => {
	emit('close')
	dialog.value = false
}
</script>

<style></style>
